const mergeSolutions = (solution, state, that, callback=nil) => {
  const updated = Object.assign(state.solutions, solution);
  that.setState(
    { solutions: updated },
    () => { if(callback) callback() }
  );
}

export default mergeSolutions;